import loading from '../helpers/loading'
import collectionPerPage from '../helpers/collectionPerPage'

import actions from './actions'

export default {
  namespaced: true,
  state: {
    ...loading.state,
    ...collectionPerPage.state
  },
  mutations: {
    ...loading.mutations,
    ...collectionPerPage.mutations
  },
  getters: {
    ...loading.getters,
    ...collectionPerPage.getters
  },
  actions
}



// WEBPACK FOOTER //
// ./src/store/skiliko/activities/index.js